module.exports = __webpack_public_path__ + "static/media/filter-icon.3bdc281f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter-icon.svg
// module id = 150
// module chunks = 0